export class Version {
    versionString: string;
    
    constructor(versionString: string) {
        this.versionString = versionString;
    }

    get parts(): number[]{
        return this.versionString 
            ? this.versionString.split(".").map(partString => parseInt(partString, 10))
            : [];
    }

    get major(){
        return this.parts.length >= 0 
            ? this.parts[0] 
            : 0;
    }

    get minor(){
        return this.parts.length >= 1 
            ? this.parts[1] 
            : 0;
    }

    get revision(){
        return this.parts.length >= 2 
            ? this.parts[2] 
            : 0;
    }

    isGreaterOrEqual(other: Version): boolean {
        return this.major > other.major
            || (this.major === other.major && this.minor > other.minor)
            || (this.major === other.major && this.minor === other.minor && this.revision >= other.revision)
    }

    toString(): string {
        return [this.major, this.minor, this.revision].join(".");
    }
   
}

export default Version;
